// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentTransactionReference {
    static getAttributeTypeMap() {
        return DigitalpaymentTransactionReference.attributeTypeMap;
    }
}
DigitalpaymentTransactionReference.discriminator = undefined;
DigitalpaymentTransactionReference.additionalProperties = false;
DigitalpaymentTransactionReference.attributeTypeMap = [
    {
        "name": "transactionKeyId",
        "baseName": "transactionKeyId",
        "type": "string"
    },
    {
        "name": "transactionKeyValue",
        "baseName": "transactionKeyValue",
        "type": "string"
    },
];
//# sourceMappingURL=digitalpaymentTransactionReference.js.map